
import React, { useEffect,useState,useLayoutEffect } from 'react'
import classNames from 'classnames'
import { Tooltip } from '@cleartrip/bento'
import Clevertap from 'analytics'
import { returnFareName } from 'constants/fareType'

function SplFareType({activeFare, fareTypeList, tripType, handleClick }) {
    const [showToolTip,SetToolTip] = useState(false)
    let defaultClass = 'flex flex-center flex-column flex-middle pl-3 pr-3 h-8 br-16 mr-2 fs-14 fw-500'
    function ClickHandler(type){
        handleClick(type)
    }

    useLayoutEffect(()=>{
        setTimeout(()=>{
            SetToolTip(true)
            setTimeout(()=>{
                sessionStorage.setItem('isPtc', true)
                SetToolTip(false)
            },5000)
        },500)

        
    },[])

    const disableClickHandler = (ele) => {
        Clevertap.event('Air_UI_Action', {
            action_name: 'ptc_fare_selection_error',
            ptc_fare: returnFareName(ele.code),
            is_ptc_selectable : returnFareName(activeFare) === 'Regular fare' ? 'no' : 'yes',
            ptc_fare_selection_error: `You cannot select ${ele.fare} with infants added to the journey`,
            journey_type_uiaction: tripType === 'O' ? 'one-way' : 'round-trip'
        })
    }

    const onHoverHandler = (code) => {
        SetToolTip(false)
        Clevertap.event('Air_UI_Action', {
            action_name: 'ptc_icon_hover',
            action_type: 'hover',
            ptc_fare: returnFareName(code),
            journey_type_uiaction: tripType === 'O' ? 'one-way' : 'round-trip'
        })
    }
    const fareTypes = fareTypeList.map((ele, idx) => {
            const selectorClass = classNames(defaultClass, {
                'bg-secondary-100 bc-secondary-500 c-secondary-500 c-pointer ba': ele.code === activeFare,
                'hover:bg-neutral-0 bc-neutral-100 c-pointer ba': ele.code !== activeFare,
            })
            const selectorClassDisable = classNames(defaultClass, {
                'bg-neutral-100 c-neutral-400':!ele.active
            })
            return (
                ele.active?<div  
                className={selectorClass}
                onClick={()=>ClickHandler(ele.code)}
                onMouseEnter={() => onHoverHandler(ele.code)}
                >
                    {ele.code == 'rf'? ele.fare:<Tooltip
                        arrow
                        position="bottom-start"
                        size="md"
                        width={250}
                        height={56}
                        distance={10}
                        offset={35}
                        content={ele.toolTipMsg}
                        className="fs-12 fw-500 p-3 bg-neutral-900 lh-16"
                        style={{
                            display: 'flex',
                            lineHeight:'16px'
                            
                        }}
                    >
                        <div className={'fs-14 fw-500'}>{ele.fare}</div>
                    </Tooltip>}
                    
            </div>:
                <div  
                    className={selectorClassDisable}
                    onClick={()=>disableClickHandler(ele)}
                    onMouseEnter={() => onHoverHandler(ele.code)}
                    >
                    
                    <Tooltip
                        arrow
                        position="bottom-start"
                        size="md"
                        width={260}
                        height={56}
                        distance={10}
                        offset={35}
                        content={ele.toolTipErrorMsg}
                        className="fs-12 fw-500 p-3 bg-neutral-900 lh-16"
                        style={{
                            display: 'flex',
                            lineHeight:'16px'
                            
                        }}
                    >
                        <div className={'fs-14 fw-500'}>{ele.fare}</div>
                    </Tooltip>
                </div>
            )
    })

    return  <div class="flex flex-row flex-middle mt-8">{fareTypes}
                        <Tooltip
                        arrow
                        open={showToolTip && !sessionStorage.getItem('isPtc')}
                        position="right"
                        size="md"
                        width={160}
                        height={82}
                        distance={10}
                        offset={0}
                        content={<span className='flex flex-column'>
                            <div className="bc-transparent flex flex-middle flex-center c-white fs-2 m-0 fw-700 br-4 box-border fw-700 h-4 mb-2" style={{width:40, background:'linear-gradient(98.12deg, #FF4F17 18.33%, #FD7C52 91.81%)'}}>
                                {'NEW'}
                            </div>
                            <p className='fs-2 fw-500'>Choose your fare type and save more</p>
                        </span>}
                        className="fs-12 fw-500 p-3 bg-neutral-900 lh-16"
                        style={{
                            display: 'flex',
                            lineHeight:'16px',
                            Padding:12,
                            
                        }}
                    >
                    </Tooltip>
    </div>
}

export default SplFareType
